import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';

import {
    MaterialFormsModule,
    MaterialUserInterfaceModule,
} from 'ng2-material-components/ng2-material-components';

import { DashboardComponent }   from './dashboard.component';
import { DashboardEmployeesComponent } from './employees';
import { DashboardInventoryComponent } from './inventory';
import { DashboardLocationsComponent } from './locations';
import { DashboardSummaryComponent } from './summary';
import { DashboardFilterSheetComponent } from './shared';

import { DashboardService } from './shared/services';

@NgModule({
    imports: [
        CommonModule,
        MaterialFormsModule,
        MaterialUserInterfaceModule,
        SharedModule,
    ],
    exports: [
        DashboardComponent,
        DashboardEmployeesComponent,
        DashboardInventoryComponent,
        DashboardLocationsComponent,
        DashboardSummaryComponent,
        DashboardFilterSheetComponent
    ],
    declarations: [
        DashboardComponent,
        DashboardEmployeesComponent,
        DashboardInventoryComponent,
        DashboardLocationsComponent,
        DashboardSummaryComponent,
        DashboardFilterSheetComponent
    ],
    providers: [
        DashboardService
    ],
})
export class DashboardModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/dashboard/dashboard.module.ts